import '../App.css';
import './Campaign.css';
import AdCreative from '../AdCreative';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loadCampaign } from '../QueryCampaign';
import CampaignAudience from './CampaignAudience';
import CampaignSettings from './CampaignSettings';
import CampaignStats from './CampaignStats';
import CampaignBudget from './CampaignBudget';
import V2HomeCard from '../V2HomeCard';
import V2Card from '../V2Card';
import CampaignMenu from './CampaignMenu';
import CampaignPreview from './CampaignPreview';
import CampaignStatus from './CampaignStatus';
import CampaignDevices from './CampaignDevices';
import { Button } from 'primereact/button';

function CampaignTop({ menu }) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [campaign, setCampaign] = useState(null);
    const [tab, setTab] = useState('/campaign/devices/');

    function getCampaign() {
        loadCampaign(searchParams.get('campaign_id')).then(
            (response) => setCampaign(response.data)
        ).catch(
            (error) => navigate('/')
        )
    }
    useEffect(
        () => {
            getCampaign();
        },
        [],
    )

    function getTabContent() {
        const campaign_id = searchParams.get('campaign_id');

        switch (tab) {
            case '/campaign/':
                return <CampaignPreview campaign_id={campaign_id} />
            case '/campaign/audience/':
                return <CampaignAudience campaign_id={campaign_id} />
            case '/campaign/devices/':
                return <CampaignDevices campaign_id={campaign_id} />
            case '/campaign/budget/':
                return <CampaignBudget campaign_id={campaign_id} />
            case '/campaign/stats/':
                return <CampaignStats campaign_id={campaign_id} />
            case '/campaign/settings/':
                return <CampaignSettings campaign_id={campaign_id} getCampaign={getCampaign} />
        }
    }

    return (
        <div align='center'>
            {menu}
            <V2Card>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {
                        campaign &&
                        <div className='v2-campaign-creative'>
                            <AdCreative
                                creativeURL={campaign.creative_url}
                                creativeExt={campaign.creative_ext}
                                height='100%'
                                width='100%'
                                objectFit='contain'
                                hideControls={true}
                            />
                        </div>
                    }
                    <div>
                        <div className='mk2-title'>
                            {campaign?.title}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', height: '3em' }}>
                            <CampaignStatus
                                status={campaign?.status}
                            />
                            <div
                                style={{ marginLeft: '1em' }}
                            >
                                {
                                    campaign?.status == 'active' && tab != '/campaign/settings/' &&
                                    <Button
                                        label='Deactivate'
                                        severity='danger'
                                        size='small'
                                        outlined
                                        onClick={() => setTab('/campaign/settings/')}
                                    />
                                }
                                {
                                    campaign?.status != 'active' && tab != '/campaign/settings/' &&
                                    <Button
                                        label='Activate'
                                        severity='success'
                                        size='small'
                                        outlined
                                        onClick={() => setTab('/campaign/settings/')}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </V2Card>
            {
                campaign &&
                <CampaignMenu
                    campaign={campaign}
                    tab={tab}
                    setTab={setTab}
                />
            }

            <V2HomeCard>
                <div
                    style={{ marginTop: '1em' }}
                >
                    {getTabContent()}
                </div>
            </V2HomeCard>
        </div >
    );
}

export default CampaignTop;